module.exports = __webpack_public_path__ + "fa-brands-400.svg?f77645622015337d638b8a3d6266fe43";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/fontAwesome-5/webfonts/fa-brands-400.svg
// module id = 357
// module chunks = 0